'use strict'

var Marionette = require('marionette')
var Backbone = require('backbone')
var App = require('app')
var _ = require('lodash')

var View = require('./view.js')
var BodyModel = require('src/common/page-model')

var ClientApiKeysList = function (options) {
  var Controller = Marionette.Object.extend({
    initialize: function (options) {
      this.region = options.region

      var self = this
      //
      self.keys = App.globalChannel.request('apikey:entities', {
        query: {
          client: options.client.get('_id')
        }
      })

      var bodyModel = new BodyModel({
        title: 'API Keys',
        buttons: [
          { label: 'add key', primary: true, slug: 'apikey', action: 'client-apikeys:add', roles: ['super', 'admin'] }
        ]
      })

      self.layout = self.getLayoutView(bodyModel)

    //  self.layout.on('childview:client-users:edit', _.bind(self.onEdit, self))
      self.listenTo(self.layout, 'client-apikeys:add', self.onAdd, self)

      self.listenTo(self.layout, 'render', function () {
        self.listRegion(self.keys)
      })

      // view events
      self.region.show(self.layout)
    },
    /* Event methods --------------------------------------------------------- */
    onBulk: function (args) {
      switch (args.bulk_action) {
        case 'delete':
          App.dialog.confirm({
            message: 'Are you sure you want to peform a bulk delete?',
            callback: function (confirmed) {
              if (confirmed) {
                args.collection.bulkDelete({})
              }
            }
          })
          break
        default:
          console.warn('Bulk action not catched by switch, "' + args.bulk_action + '"')
          break
      }
    },
    onAdd: function (args) {
      var self = this
      App.globalChannel.trigger('client-apikeys:new', {region: App.rootLayout.getRegion('dialogRegion'), client: self.options.client, collection: self.keys})
    },
    onRender: function (args) {
      // App.globalChannel.trigger('client:show', {model: args.model})
    },
    onEdit: function (args) {
      App.globalChannel.trigger('client-apikeys:edit', {region: App.rootLayout.getRegion('dialogRegion'), model: args.model})
    },
    /* Regions --------------------------------------------------------------- */
    listRegion: function (nodes, columns) {
      var self = this
      //
      var columns = {
        'enabled': {'label': '', 'sortable': false, 'roles': [] },
        'name': {'label': 'name', 'sortable': true, 'roles': [] },
        'key': {'label': 'key', 'sortable': true, 'roles': [], 'hideSizes':['mobile']},
        'createdAt': {'label': 'created at', 'sortable': true, 'roles': [], 'hideSizes':['mobile','tablet']},
        'lastUsedAt': {'label': 'last used', 'sortable': true, 'roles': [], 'hideSizes':['mobile','tablet']},
        '_actions': {
          'options': {
            'edit': { 'action': 'edit', 'roles': [] }
          }
        }
      }

      //
      var emptyViewModel = new Backbone.Model({
        title: 'No API Keys yet.',
        subTitle: 'create some keys to get started'
      })

      //
      var layout = this.getListView(nodes, columns, emptyViewModel)
      self.listenTo(layout, 'listview:childview:item:edit', self.onEdit)
      self.listenTo(layout, 'listview:childview:item:manage', self.onManage)
      self.listenTo(layout, 'listview:childview:item:click', self.onEdit)
      self.listenTo(layout, 'bulk:action', self.onBulk)

      self.layout.getRegion('listRegion').show(layout)
    },
    /* Views ----------------------------------------------------------------- */
    getListView: function (collection, columns, emptyViewModel) {
      // create the listview based on the list component
      return new View.ListView({
        collection: collection,
        columns: columns,
        emptyViewModel: emptyViewModel,
        childView: View.ListItem // use a custom childview
      })
    },
    getLayoutView: function (model) {
      return new View.Layout({model: model})
    }
  })

  return new Controller(options)
}

module.exports = ClientApiKeysList



// WEBPACK FOOTER //
// ./js/modules/client-apikeys/list/index.js